import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Interviews from './interviews';
import Options from './options';
import MatchRules from './match-rules';
import MatchTest from './match-test';
import ConversationHistory from './conversation-history';
import UserProfile from './user-profile';
import UserMatches from './user-matches';
import MatchmakerChat from './matchmaker-chat';
import Events from './events';
import PrintCardPage from './events/printCardPage';
import QrPosterPage from './events/qrPosterPage';
import VectorLabels from './vector-labels';
import AppVersions from './app-versions';
import Overview from './overview';
import WinBack from './win-back';

import {
  useFindManyOptionsQuery,
  useGetProfileFieldsQuery,
} from 'src/store/optionApi';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppShell } from 'src/ui/shell';
import { setConstant } from 'src/store/constantsSlice';
import { setOptions } from 'src/store/optionSlice';

const CHROMELESS_PATHS = [
  /^\/events\/[^/]+\/print-card\/[^/]+\/?$/,
  /^\/events\/[^/]+\/qr-poster\/?$/,
];

const Router = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const chromeless = CHROMELESS_PATHS.some((re) => re.test(location.pathname));
  const { data: profileFields } = useGetProfileFieldsQuery();
  useEffect(() => {
    if (!profileFields) return;
    dispatch(setConstant(['profileFields', profileFields]));
  }, [profileFields, dispatch]);

  const { data: optionData, refetch: refetchOptions } =
    useFindManyOptionsQuery();

  useEffect(() => {
    if (!optionData?.data) return;
    dispatch(setOptions(optionData.data));
  }, [optionData, dispatch]);

  const routes = (
    <Routes>
      <Route path="overview" element={<Overview />} />
      <Route path="interviews/*" element={<Interviews />} />
      <Route path="events" element={<Events />} />
      <Route path="events/:eventId" element={<Events />} />
      <Route
        path="events/:eventId/print-card/:userId"
        element={<PrintCardPage />}
      />
      <Route path="events/:eventId/qr-poster" element={<QrPosterPage />} />
      <Route
        path="options/*"
        element={<Options refetchAll={refetchOptions} />}
      />
      <Route path="match-rules/*" element={<MatchRules />} />
      <Route path="match-test/*" element={<MatchTest />} />
      <Route path="conversation-history/*" element={<ConversationHistory />} />
      <Route path="user-profile" element={<UserProfile />} />
      <Route path="user-profile/:userId" element={<UserProfile />} />
      <Route path="user-matches/:userId" element={<UserMatches />} />
      <Route path="matchmaker-chat/*" element={<MatchmakerChat />} />
      <Route path="vector-labels" element={<VectorLabels />} />
      <Route path="win-back" element={<WinBack />} />
      <Route path="app-versions" element={<AppVersions />} />
      <Route path="*" element={<Navigate to="/overview" />} />
    </Routes>
  );

  if (chromeless) {
    return routes;
  }

  return <AppShell>{routes}</AppShell>;
};

export default Router;
